// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3FC3S","title":"Images90_title__y32oq","images":"Images90_images__1mzqw"};